import {
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    Grid,
    Box,
    MenuItem
} from '@mui/material';
import { useState, useEffect } from 'react';
import DatePickerField from "../../../common/DatePickerDashboard";
import { stateList } from '../../../common/StaticFieldList';

const YEARS = [
  ...Array.from({ length: 13 }, (_, i) => i.toString()),
  "12+"
];

const MONTHS = Array.from({ length: 13 }, (_, i) => i.toString());

const RequiredLabel = ({ children, required = false }) => (
    <label className='fnt-we'>
        {children}
        {required && <span style={{ color: '#d32f2f', marginLeft: '4px' }}>*</span>}
    </label>
);

const EditPolicyUserDetail = ({ formData, handleChange, handleDialogClose, handleSubmit }) => {
    const [errors, setErrors] = useState({});
    const [touchedFields, setTouchedFields] = useState({});
    const [fieldErrors, setFieldErrors] = useState({});

const [didPrefill, setDidPrefill] = useState(false);

useEffect(() => {
  if (didPrefill) return;

  const more = formData?.residenceMoreThan;
  const yr = formData?.residenceYear;

  if (more === true && (yr === 12 || yr === "12")) {
    handleChange({ target: { name: "residenceYear", value: "12+" } });
  }

  if (more === false && yr === "12+") {
    handleChange({ target: { name: "residenceYear", value: "12" } });
  }

  setDidPrefill(true);
}, [formData?.residenceMoreThan, formData?.residenceYear, handleChange, didPrefill]);

    const handleDateChange = (fieldName, value) => {
        let formattedValue = value;
        if (value && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
            const [year, month, day] = value.split('-');
            formattedValue = `${month}-${day}-${year}`;
        }

        const syntheticEvent = {
            target: {
                name: fieldName,
                value: formattedValue
            }
        };
        handleChange(syntheticEvent);
    };

    const handleDateBlur = (fieldName, errorMessage) => {
        setTouchedFields(prev => ({
            ...prev,
            [fieldName]: true
        }));

        setFieldErrors(prev => ({
            ...prev,
            [fieldName]: errorMessage
        }));
    };

    const validate = () => {
        let tempErrors = {};

        if (!formData.firstName) tempErrors.firstName = "First Name is required";
        if (!formData.lastName) tempErrors.lastName = "Last Name is required";
        if (!formData.dateOfBirth) tempErrors.dateOfBirth = "Date of Birth is required";
        if (!formData.gender) tempErrors.gender = "Gender is required";
        if (!formData.emailId) tempErrors.emailId = "Email is required";
        if (!formData.address) tempErrors.address = "Address is required";
        if (!formData.zipCode) tempErrors.zipCode = "Zip is required";
        if (!formData.city) tempErrors.city = "City is required";
        if (!formData.state) tempErrors.state = "State is required";
        if (!formData.residenceYear) tempErrors.residenceYear = "Years at Residence is required";
        if (!formData.residenceMonth) tempErrors.residenceMonth = "Months at Residence is required";
        if (formData.emailId && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.emailId)) {
            tempErrors.emailId = "Please enter a valid email address";
        }

        setErrors(tempErrors);
        return Object.keys(tempErrors).length === 0;
    };

    const handleSubmitWithValidation = (e) => {
        e.preventDefault();
        if (validate()) {
            const payload = {
            ...formData,
            residenceMoreThan:
                formData.residenceYear === "12+" || formData.residenceMoreThan === true,
            residenceYear: formData.residenceYear === "12+" ? "12" : formData.residenceYear,
            };

            handleSubmit(payload);
        }
    };

    return (
        <form onSubmit={handleSubmitWithValidation}>
            <DialogTitle >Edit Policy Details</DialogTitle>
            <DialogContent  sx={{ maxHeight: "65vh", overflowY: "auto", p: 2, }}>
                <Grid container spacing={2} sx={{ mt: 2 }}>
                    <Grid item xs={12} sm={6}>
                        <Box sx={{ mb: 2 }}>
                            <RequiredLabel required>First Name</RequiredLabel>
                            <TextField
                                name="firstName"
                                value={formData.firstName || ''}
                                onChange={(e) => {
                                    const { value } = e.target;
                                    if (/^[a-zA-Z0-9 ]*$/.test(value) && value.length <= 30) {
                                        handleChange(e);
                                    }
                                }}
                                fullWidth
                                error={!!errors.firstName}
                                helperText={errors.firstName}
                                required
                            />
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Box sx={{ mb: 2 }}>
                            <RequiredLabel required>Last Name</RequiredLabel>
                            <TextField
                                name="lastName"
                                value={formData.lastName || ''}
                                onChange={(e) => {
                                    const { value } = e.target;
                                    if (/^[a-zA-Z0-9 ]*$/.test(value) && value.length <= 30) {
                                        handleChange(e);
                                    }
                                }}
                                fullWidth
                                error={!!errors.lastName}
                                helperText={errors.lastName}
                                required
                            />
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Box sx={{ mb: 2 }}>
                            <RequiredLabel required>Date of Birth</RequiredLabel>
                            <DatePickerField
                                fieldName="dateOfBirth"
                                formData={formData}
                                handleDateChange={handleDateChange}
                                handleBlur={handleDateBlur}
                                touchedFields={touchedFields}
                                fieldErrors={fieldErrors}
                            />
                            {errors.dateOfBirth && (
                                <div style={{
                                    color: '#d32f2f',
                                    fontSize: '0.75rem',
                                    marginTop: '3px',
                                    marginLeft: '14px'
                                }}>
                                    {errors.dateOfBirth}
                                </div>
                            )}
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Box sx={{ mb: 2 }}>
                            <RequiredLabel required>Gender</RequiredLabel>
                            <TextField
                                select
                                name="gender"
                                value={formData.gender || ''}
                                onChange={handleChange}
                                fullWidth
                                error={!!errors.gender}
                                helperText={errors.gender}
                                required
                            >
                                <MenuItem value="M">Male</MenuItem>
                                <MenuItem value="F">Female</MenuItem>
                                <MenuItem value="Other">Other</MenuItem>
                            </TextField>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Box sx={{ mb: 2 }}>
                            <RequiredLabel required>Email</RequiredLabel>
                            <TextField
                                name="emailId"
                                value={formData.emailId || ''}
                                onChange={(e) => {
                                    const { value } = e.target;
                                    if (/^[a-zA-Z0-9@._-]*$/.test(value) && value.length <= 50) {
                                        handleChange(e);
                                    }
                                }}
                                fullWidth
                                error={!!errors.emailId}
                                helperText={errors.emailId}
                                required
                            />
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Box sx={{ mb: 2 }}>
                            <RequiredLabel required>Address</RequiredLabel>
                            <TextField
                                name="address"
                                value={formData.address || ''}
                                onChange={(e) => {
                                    const { value } = e.target;
                                    if (/^[a-zA-Z0-9 ,.-]*$/.test(value) && value.length <= 100) {
                                        handleChange(e);
                                    }
                                }}
                                fullWidth
                                error={!!errors.address}
                                helperText={errors.address}
                                required
                            />
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Box sx={{ mb: 2 }}>
                            <RequiredLabel required>Zip</RequiredLabel>
                            <TextField
                                name="zipCode"
                                value={formData.zipCode || ''}
                                onChange={(e) => {
                                    const { value } = e.target;
                                    if (/^[0-9]*$/.test(value) && value.length <= 5) {
                                        handleChange(e);
                                    }
                                }}
                                fullWidth
                                error={!!errors.zipCode}
                                helperText={errors.zipCode}
                                required
                            />
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Box sx={{ mb: 2 }}>
                            <RequiredLabel required>City</RequiredLabel>
                            <TextField
                                name="city"
                                value={formData.city || ''}
                                onChange={(e) => {
                                    const { value } = e.target;
                                    if (/^[a-zA-Z ]*$/.test(value) && value.length <= 30) {
                                        handleChange(e);
                                    }
                                }}
                                fullWidth
                                error={!!errors.city}
                                helperText={errors.city}
                                required
                            />
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Box sx={{ mb: 2 }}>
                            <RequiredLabel required>State</RequiredLabel>
                            <TextField
                                select
                                name="state"
                                value={formData.state || ''}
                                onChange={handleChange}
                                fullWidth
                                error={!!errors.state}
                                helperText={errors.state}
                                required
                            >
                                {stateList.map((state) => (
                                    <MenuItem key={state.value} value={state.value}>
                                        {state.label}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Box sx={{ mb: 2 }}>
                            <RequiredLabel required>Years at Residence</RequiredLabel>
                          <TextField
                            select
                            name="residenceYear"
                            value={formData.residenceYear || ''}
                            onChange={(e) => {
                                const { value } = e.target;

                                if (value === "12+") {
                                handleChange({ target: { name: "residenceMoreThan", value: true } });
                                } else {
                                handleChange({ target: { name: "residenceMoreThan", value: false } });
                                }
                                handleChange({ target: { name: "residenceYear", value } });
                            }}
                            fullWidth
                            error={!!errors.residenceYear}
                            helperText={errors.residenceYear}
                            required
                            >
                            {YEARS.map((year) => (
                                <MenuItem key={year} value={year}>
                                {year}
                                </MenuItem>
                            ))}
                            </TextField>

                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Box sx={{ mb: 2 }}>
                            <RequiredLabel required>Months at Residence</RequiredLabel>
                            <TextField
                                select
                                name="residenceMonth"
                                value={formData.residenceMonth || ''}
                                onChange={handleChange}
                                fullWidth
                                error={!!errors.residenceMonth}
                                helperText={errors.residenceMonth}
                                required
                            >
                                {MONTHS.map((month) => (
                                    <MenuItem key={month} value={month}>
                                        {month}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Box>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button variant='outlined' size='large' onClick={handleDialogClose}>Cancel</Button>
                <Button variant='outlined' size='large' type="submit">Save</Button>
            </DialogActions>
        </form>
    );
};

export default EditPolicyUserDetail;